import { ListItemButton, ListItemText, useTheme } from "@mui/material";
import { FilterDefinition } from "../../../../../../../context/FiltersProvider/types";

type Props = {
	filter: FilterDefinition;
	onSelect: (filter: FilterDefinition) => void;
	selected?: boolean;
};

export const RootCauseFilterListItem = ({ filter, onSelect, selected }: Props) => {
	const theme = useTheme();

	return (
		<ListItemButton
			onClick={() => onSelect(filter)}
			disabled={selected}
			sx={{ background: selected ? theme.palette.grey[300] : "none" }}
		>
			<ListItemText primary={filter.name} />
		</ListItemButton>
	);
};
